import type { Environment } from '@/stores';

/** Environment badge pill color style — matches GCP project badge (blue-grey with white text). */
export const ENV_BADGE_STYLE = 'bg-[#5f6368] text-white';

/** Short environment display names for badge pills. */
export const ENV_SHORT_NAMES: Record<Environment, string> = {
  staging: 'Test',
  development: 'Dev',
  production: 'Prod',
};
